import React, { createContext, useContext, useState } from 'react';

interface NavContextType {
    isCollapsed: boolean;
    setIsCollapsed: (collapsed: boolean) => void;
    forceCollapsed: boolean;
    setForceCollapsed: (collapsed: boolean) => void;
}

const NavContext = createContext<NavContextType | undefined>(undefined);

export const NavProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
    const [forceCollapsed, setForceCollapsed] = useState<boolean>(false);

    return (
        <NavContext.Provider
            value={{
                isCollapsed,
                setIsCollapsed,
                forceCollapsed,
                setForceCollapsed,
            }}
        >
            {children}
        </NavContext.Provider>
    );
};

export const useNavContext = () => {
    const context = useContext(NavContext);
    if (!context) {
        // Return a default fallback if context is not available
        return {
            isCollapsed: false,
            setIsCollapsed: () => {},
            forceCollapsed: false,
            setForceCollapsed: () => {},
        };
    }
    return context;
};

export default NavContext;
